/**
 * ECharts is loaded on demand through a local runtime with statically named
 * imports. That keeps this boundary lazy while allowing the bundler to remove
 * chart types and components we do not register. Cached in-module so multiple
 * `LemmonChart` instances on one page share a single import.
 */
let corePromise: Promise<typeof import("./echartsRuntime")> | null = null;

export async function loadEcharts() {
  if (!corePromise) {
    corePromise = import("./echartsRuntime");
  }
  return corePromise;
}
